export default {
    center:  'center',
    default: 'default',
};
